import { defineStore } from 'pinia';
import { useNuxtApp } from 'nuxt/app';
import { ref } from 'vue';
import { setErrorNotification } from '~~/common/utils/helper';
import { useUserStore } from '~~/common/stores/user';
import type { Schema } from '~~/common/types/api';

export const useGdprStore = defineStore('gdpr', () => {
  const userStore = useUserStore();
  const nuxtApp = useNuxtApp();

  const acceptance = ref<Schema<'MeModel.GdprAcceptanceModel'> | null>(null);

  async function fetchAcceptance () {
    const {
      $api,
      $logger,
    } = nuxtApp;

    if (userStore.isEcomUser) {
      try {
        acceptance.value = await $api.$get<Schema<'MeModel.GdprAcceptanceModel'>>('/me/gdpr/acceptance');
      } catch (error) {
        $logger.error(error);
        setErrorNotification({ nuxtApp, error });
      }
    }
  }

  async function updateAcceptance () {
    const {
      $api,
      $logger,
    } = nuxtApp;

    try {
      await $api.$post('/me/gdpr/acceptance', {});
    } catch (error) {
      $logger.error(error);
      setErrorNotification({ nuxtApp, error });
    }
  }

  return {
    acceptance,
    fetchAcceptance,
    updateAcceptance,
  };
});
